 <template>
  <div
    id="brandCountBarcodeModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <!-- Begin: table -->
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable" 
                      ><thead>
                        <tr>
                          <th class="text-center">ลำดับ</th>
                          <th class="text-center">BARCODE</th>
                          <th class="text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, i) in items" :key="i">
                                <td class="text-center">{{i + 1}}</td>
                                <td class="text-center">{{row.barcodeNoOld}}</td>
                                <td class="text-center">{{row.departmentMaterialCode}}</td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <div class="form-group">
                      <label class="label-required">รหัสอ้างอิง:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control'"
                        :id="'DlbRefno'"
                        :name="'DlbRefno'"
                        :select2-options="DlbRefnoOptions"
                        :multiple="true"
                        v-model="DlbRefno"
                        ref="DlbRefnoSelect2"
                      ></select2>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
    
  },
  data: function() {
    var self = this;
    return {
      items : []
    };
  },
  methods: {
    formSubmit: function(e) {

    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $("#brandCountBarcodeModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        //self.$parent.reloadDataTable(false);
      })
      .modal("show");

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
    });

    axios
      .get("/Api/Report/BrandCount/Barcode/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            self.items = response.data;
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Report/BrandCountBarcodeModal.vue